import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import {getLanguages} from "../../../redux/actions/languageActions";
import {compose} from "redux";
import {connect} from "react-redux";
import List from "@material-ui/core/List";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListItem from "@material-ui/core/ListItem";
let t=null;

class Language extends Component {
    static propTypes = {
        i18n: PropTypes.shape({ changeLanguage: PropTypes.func }).isRequired,
    };
    constructor(props) {
        super(props);
        this.state = {
            collapse: false,
        };
        t = props.t;
    }

    componentDidMount() {

        if(this.props.languages.length === 0)
        {
            this.props.getLanguages();
        }
    }

    changeLanguage = (lng) => {
        const { i18n } = this.props;
        i18n.changeLanguage(lng);
    };

    render() {
        const { i18n } = this.props;
        // "tr-TR" gibi bölgesel kodları da eşleştir
        const activeCode = String(i18n.language || '').slice(0, 2).toLowerCase();
        const languagesArray = Array.isArray(this.props.languages) ? this.props.languages : [];
        const sortedLanguages = [...languagesArray].sort((a, b) => {
            const order = ['tr', 'en'];
            const aIndex = order.indexOf(a.code);
            const bIndex = order.indexOf(b.code);
            if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
            if (aIndex !== -1) return -1;
            if (bIndex !== -1) return 1;
            return 0;
        });

        return (
            <List component="nav" aria-label="language list" className="language-list">
                {
                    sortedLanguages.length > 0 && sortedLanguages.map((language) => (
                        language && language.code && language.language_key && (
                            <ListItem
                                key={language.code}
                                className={activeCode === language.code ? 'is-active-language' : ''}
                                onClick={() => this.changeLanguage(language.code, language.language_key)}
                                button
                            >
                                <ListItemIcon style={{minWidth: 40}}>
                                    <img style={{width:"20px"}} src={`/assets/img/language/${language.code}.svg`} alt={language.code} />
                                </ListItemIcon>
                                <ListItemText primary={t(language.language_key)} />
                            </ListItem>
                        )
                    ))
                }
            </List>
        )
    }
}

const mapStateToProps = (props) => {
    return {
        languages : props.languagesReducer.languages,
    }
};

const mapDispatchToProps ={
    getLanguages
};

export default compose(withTranslation('common')) (connect(mapStateToProps, mapDispatchToProps )(Language));
